<template>
  <div class="app-placeholder">
    <el-empty :description="title + ' 功能开发中...'" />
  </div>
</template>

<script>
export default {
  name: 'GenericApp',
  computed: {
    title() {
      return this.$route.meta.title || '应用'
    }
  }
}
</script>

<style scoped>
.app-placeholder {
  padding: 40px;
  background: #fff;
  min-height: 100%;
}
</style>